
import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VLine from 'vux/src/components/v-chart/v-line.vue'
import VArea from 'vux/src/components/v-chart/v-area.vue'
import VTooltip from 'vux/src/components/v-chart/v-tooltip.vue'
import VLegend from 'vux/src/components/v-chart/v-legend.vue'
import VBar from 'vux/src/components/v-chart/v-bar.vue'
import VPie from 'vux/src/components/v-chart/v-pie.vue'
import VGuide from 'vux/src/components/v-chart/v-guide.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'

import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import XHeader from 'vux/src/components/x-header/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import XDialog from 'vux/src/components/x-dialog/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import Icon from 'vux/src/components/icon/index.vue'

import { setTimeout } from 'timers';
import Alert from 'vux/src/components/alert/index.vue'

import Toast from 'vux/src/components/toast/index.vue'

import XTextarea from 'vux/src/components/x-textarea/index.vue'

import dateFormat from 'vux/src/tools/date/format.js'
import base64 from 'vux/src/tools/base64/index.js'

import { resolveMediaUrl } from '@/utils/mediaUrl'
import newApi from '@/utils/newModuleApi'
import { buildMeanAndExampleHtml } from '@/utils/wordHighlight'
const map = {}
export default {
directives: {
TransferDom
},
filters: {
dateFormat
},
components: {
XInput,
XButton,
Group,
Cell,
VChart,
VLine,
VArea,
VTooltip,
VLegend,
VBar,
VPie,
VGuide,
VScale,
XHeader,
Divider,
Flexbox,
FlexboxItem,
Swiper,
SwiperItem,
Alert,
Toast,
XDialog,
XTextarea,
Icon
},
data() {
return {
highlightStyle: `
position: relative;
color: #212121;
background: #fff3b0;
padding: 2px 5px;
border-radius: 4px;
`,
jumPtOtype:'',
value1: '1',
message: {},
wsongUrl: '',
wordList: [],
index: 0,
isStarred: false,
show: true,
flag: false,
list: [],
showDeil: true,
height: '0px',
position: 'middle',
showPositionValue: false,
total: 0,
pageNo: 1,
type: '',
name: '',
count: 0,
toastText: '进行下一阶段',
showToast: false,
showVideo: false,
showVideoFlag: false,
saveFeedBackSuccess: false,
saveFeedBackError: false,
feedback: '',
audio: {
currentTime: 0,
maxTime: 0,
playing: false,
muted: false,
speed: 1,
waiting: true,
preload: 'auto'
},
controlList: {

noDownload: true,

noMuted: true,

noVolume: false,

noProcess: false,

onlyOnePlaying: false,

noSpeed: true
},
exchange: [],
userFavoritesList: [],
wordinfo: {
word: '',
yvideo: '',
mvideo: ''
},
detailedWord: {
},
wordNavigateStack: []
}
},
created() {
this.jumPtOtype = this.$route.query.jumPtOtype


let data = { name: '核心高频词汇600-1', count: '100', type: 'f0a1e35f38ae4cc0bc410b203c523471', pageNo: '1', percount: 100 }
this.pageNo = data.pageNo;
this.name = data.name;
this.type = data.type;
this.count = data.count;
this.percount = data.percount;
if (this.$route.query.word != null) {
this.loadData(this.type, true);
}
if (this.$route.query.wordList != null) {
this.loadListData(this.type, true);
}


var date = dateFormat(new Date(), 'YYYY-MM-DD');
},
mounted() {
var that = this;
this.$store.state.isShowBarKey = false;
$(".feedbackCard").click(function () {
$(this).toggleClass("feedbackActive");
});
this.$nextTick(function () {
const vh = document.documentElement.clientHeight || window.innerHeight;
if (that.$refs.swiper && that.$refs.swiper.xheight !== undefined) {
that.$refs.swiper.xheight = (vh - 46 - 50) + "px";
}
});
this.lockPageScroll();
},
beforeDestroy() {
this.unlockPageScroll();
},
computed: {
processedMean () {
if (!this.detailedWord || !this.detailedWord.mean) return ''
return buildMeanAndExampleHtml(this.detailedWord.mean, this.detailedWord.example, { style: this.highlightStyle }).processedMean
},
processedExample() {
if (!this.detailedWord || !this.detailedWord.mean || !this.detailedWord.example) {
return this.detailedWord.example || '';
}
return buildMeanAndExampleHtml(this.detailedWord.mean, this.detailedWord.example, { style: this.highlightStyle }).processedExample
},
processedWordSplit() {
if (!this.detailedWord || !this.detailedWord.wordSplit) {
return '';
}
const raw = String(this.detailedWord.wordSplit).replace(/<[^>]+>/g, '');
const plusStyle = this.wordPartPlusStyle();
const chipStyle = this.wordPartChipStyle(false);
return raw.split('+')
.map(function (p) { return p.trim(); })
.filter(Boolean)
.map(part => '<span class="word-part" style="' + chipStyle + '">' + this.escapeHtml(part) + '</span>')
.join('<span class="word-part-plus" style="' + plusStyle + '">+</span>');
},
processedWordIde() {
if (!this.detailedWord || !this.detailedWord.wordIde) {
return '';
}
const raw = String(this.detailedWord.wordIde).replace(/<[^>]+>/g, '');
const plusStyle = this.wordPartPlusStyle();
const that = this;
return raw.split(/\s*\+\s*/)
.map(function (seg) { return that.formatIdeSegment(seg); })
.join('<span class="word-part-plus" style="' + plusStyle + '">+</span>');
}
},
methods: {
lockPageScroll() {
const viewBoxBody = document.getElementById('vux_view_box_body');
if (viewBoxBody) {
this._prevViewBoxOverflow = viewBoxBody.style.overflow;
this._prevViewBoxHeight = viewBoxBody.style.height;
viewBoxBody.style.overflow = 'hidden';
viewBoxBody.style.height = '100%';
}
const routerView = this.$el && this.$el.parentElement;
if (routerView && routerView.classList.contains('router-view')) {
this._prevRouterOverflow = routerView.style.overflow;
this._prevRouterHeight = routerView.style.height;
routerView.style.overflow = 'hidden';
routerView.style.height = '100%';
}
},
unlockPageScroll() {
const viewBoxBody = document.getElementById('vux_view_box_body');
if (viewBoxBody) {
viewBoxBody.style.overflow = this._prevViewBoxOverflow || '';
viewBoxBody.style.height = this._prevViewBoxHeight || '';
}
const routerView = this.$el && this.$el.parentElement;
if (routerView && routerView.classList.contains('router-view')) {
routerView.style.overflow = this._prevRouterOverflow || '';
routerView.style.height = this._prevRouterHeight || '';
}
},
escapeHtml(unsafe) {
return unsafe.replace(/[&<"'>]/g, function (match) {
return {
'&': '&amp;',
'<': '&lt;',
'>': '&gt;',
'"': '&quot;',
"'": '&#39;'
}[match];
});
},

extractKeywords(meanText) {

const cleanedText = meanText.replace(/^.*?\s/, '').replace(/[^\u4e00-\u9fa5]+/g, ' ');

return [...new Set(cleanedText.split(/\s+/).filter(word => word.trim()))];
},


escapeRegExp(text) {
return text
.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
.replace(/</g, '&lt;')
.replace(/>/g, '&gt;');
},
wordPartChipStyle(isLink) {
var base = 'display:inline-block;font-weight:600;line-height:1.35;margin:0 1px;border-radius:4px;vertical-align:baseline;';
if (isLink) {
return base + 'color:#1989fa;background:#eef5ff;border:1px solid rgba(25,137,250,0.45);cursor:pointer;text-decoration:underline;text-underline-offset:2px;text-decoration-thickness:1px;';
}
return base + 'color:#555;background:#f4f7fb;border:1px solid #dde4ec;';
},
wordPartPlusStyle() {
return 'color:#b0bac5;font-weight:500;margin:0 3px;';
},
formatIdeSegment(segment) {
var trimmed = segment.trim();
var match = trimmed.match(/^(\w+)((?:[(（][^)）]+[)）]).*|(?:英文|拼音|象形|形象|音标|词根|口诀).*)$/);
if (!match) {
return this.escapeHtml(trimmed);
}
var word = match[1];
var rest = match[2];
var isEnglish = /^(?:[(（]英文[)）]|英文)/.test(rest);
var escapedWord = this.escapeHtml(word);
var chip = isEnglish
? '<span class="word-part word-part--link word-ide-link" style="' + this.wordPartChipStyle(true) + '" data-word="' + escapedWord + '">' + escapedWord + '</span>'
: '<span class="word-part" style="' + this.wordPartChipStyle(false) + '">' + escapedWord + '</span>';
return chip + this.escapeHtml(rest);
},
onWordIdeClick(e) {
const link = e.target.closest('.word-part--link');
if (link && link.dataset.word) {
e.preventDefault();
this.jumpToEnglishWord(link.dataset.word);
}
},
saveWordNavigateState() {
this.wordNavigateStack.push({
detailedWord: { ...this.detailedWord },
wordinfo: { ...this.wordinfo },
index: this.index,
exchange: [...this.exchange]
});
},
restoreWordNavigateState() {
const prev = this.wordNavigateStack.pop();
if (!prev) return false;
this.detailedWord = prev.detailedWord;
this.wordinfo = prev.wordinfo;
this.index = prev.index;
this.exchange = prev.exchange;
return true;
},
clearWordNavigateStack() {
this.wordNavigateStack = [];
},
jumpToEnglishWord(englishWord) {
const that = this;
this.saveWordNavigateState();
this.$ajax.get(this.$api.messageMessageBoardgetByWord + "?word=" + encodeURIComponent(englishWord) + "&type=back").then(response => {
if (response && response.length > 0) {
that.getWordByid(response[0].id);
} else {
that.restoreWordNavigateState();
that.toastText = '未找到单词「' + englishWord + '」';
that.showPositionValue = true;
}
}, () => {
that.restoreWordNavigateState();
that.toastText = '加载单词失败，请稍后重试';
that.showPositionValue = true;
});
},
goReturn(){
if (this.wordNavigateStack.length > 0) {
this.restoreWordNavigateState();
return;
}
if(this.jumPtOtype=='back'){
this.$router.go(-2);
}else{
this.$router.push({ path: '/home?hideTrans=true' })
}
},
toggleStarWord () {
const wordId = this.detailedWord && this.detailedWord.id
if (!wordId) return
const next = !this.isStarred
this.$ajax.post(newApi.reviewToggleStar, { word_id: wordId, is_star: next }).then(() => {
this.isStarred = next
this.toastText = next ? '已标为重点单词' : '已取消重点'
this.showPositionValue = true
}).catch(() => {
this.toastText = '操作失败'
this.showPositionValue = true
})
},
loadWordStarStatus (wordId) {
if (!wordId) {
this.isStarred = false
return
}
this.$ajax.get(newApi.reviewWordStar + '?word_id=' + wordId).then(res => {
this.isStarred = !!(res && res.is_star)
}).catch(() => {
this.isStarred = false
})
},
closePopup: function () {

},
closeVideo: function () {
this.showVideo = false;
$("#videoTemp").empty();
this.player.dispose();
},
showVideoBtn: function (url) {


this.showVideo = true;
$("#videoTemp").append('<video id="my-player" class="video-js" controls preload="auto"  data-setup="{}"> <source src="' + url + '" type="video/mp4"></source></video>');
this.player = videojs('my-player', {}, function () {
this.on('fullscreenchange', function (event) {
if (!this.showVideoFlag) {
screen.orientation.lock('landscape');
this.showVideoFlag = true;
} else {
screen.orientation.lock("portrait");
this.showVideoFlag = false;
}
})
});
this.player.play();
},
getWordByid: function (wordId) {
this.exchange = []
this.isStarred = false
this.$ajax.get(this.$api.getPmsPmsWordsById + "?pkId=" + wordId).then(response => {
this.detailedWord = response;
this.loadWordStarStatus(this.detailedWord && this.detailedWord.id)

if( this.detailedWord.pmsImg!=null){

this.detailedWord.pmsImg = resolveMediaUrl(this.detailedWord.pmsImg)
}

if (this.detailedWord.express != null && this.detailedWord.express != '') {
let exchangedata = JSON.parse(this.detailedWord.express);
for (let key in exchangedata) {
let obj = {};
let wordState = '';
if (key == "word_third") {
wordState = "第三人称单数"
} else if (key == "word_name") {
wordState = "原文query"
} else if (key == "word_means") {
wordState = "单词含义，数组"
} else if (key == "exchange") {
wordState = "不同时态"
} else if (key == "word_done") {
wordState = "过去式"
} else if (key == "word_pl") {
wordState = "复数"
} else if (key == "word_past") {
wordState = "过去分词"
} else if (key == "word_ing") {
wordState = "现在分词"
} else if (key == "word_er") {
wordState = "比较级"
} else if (key == "word_proto") {
wordState = "原型"
} else if (key == "word_est") {
wordState = "最高级"
} else {
wordState = key
}

obj.wordct = wordState
obj.word = exchangedata[key]
this.exchange.push(obj)

}
}

}, response => {

that.$vux.loading.hide(); 
});
},

closeDialog: function () {
this.showToast = false;
$(".feedbackActive").removeClass("feedbackActive");
this.feedback = "";
},
goBack: function () {
this.$router.push({ path: '/home?hideTrans=true' })
},

saveFeedBack: function () {
var that = this;
var key = "";
$(".feedbackActive").each(function (index, item) {
key = key + $(item).attr("id") + ",";
});
if (this.message.content.length == 0) {
this.$vux.toast.text('请输入建议', 2000);
return;
}
that.$vux.loading.show({
text: '加载中...'
});






this.$ajax.post(this.$api.messageMessageBoardAdd, this.message).then(result => {
that.$vux.loading.hide(); 
that.saveFeedBackSuccess = true;
that.showToast = false;
$(".feedbackActive").removeClass("feedbackActive");
that.feedback = "";
})


},
showDialog: function () {

this.showToast = true;
$("#feedback").find("textarea").focus();
},
forId: function (index) {
return "my-player" + index
},
loadData: function (id, first) {
let that = this;



this.$ajax.get(this.$api.messageMessageBoardgetByWord + "?word=" + this.$route.query.word+"&type="+this.jumPtOtype).then(response => {


that.$vux.loading.hide();
this.wordList = response
this.wordinfo = this.wordList[0]
this.getWordByid(this.wordinfo.id)


}, response => {

that.$vux.loading.hide(); 
});


},
loadListData: function (id, first) {
let that = this;



this.$ajax.get(this.$api.getPmsWordsWordByFavoriteId + "?ids=" + this.$route.query.wordList).then(response => {


that.$vux.loading.hide();
this.wordList = response
this.wordinfo = this.wordList[0]
this.getWordByid(this.wordinfo.id)


}, response => {

that.$vux.loading.hide(); 
});


},
onError() {
this.audio.waiting = true

},

onWaiting(res) {

},

onPlay(res) {
this.audio.playing = true
this.audio.loading = false
if (!this.controlList.onlyOnePlaying) {
return
}
const target = res.target
const audios = document.getElementsByTagName('audio');
[...audios].forEach((item) => {
if (item !== target) {
item.pause()
}
})
},
onSwipeChange(newIndex) {

if (this.prevIndex !== null && this.prevIndex !== newIndex) {
this.cleanupPreviousImages(this.prevIndex);
}
this.prevIndex = newIndex;

const currentWord = this.wordList[newIndex];
this.getWordByid(currentWord.id, currentWord.wordId);




},

onTimeupdate(res) {
this.audio.currentTime = res.target.currentTime
this.sliderTime = parseInt(this.audio.currentTime / this.audio.maxTime * 100)
const _this = this
},


onLoadedmetadata(res) {
this.audio.waiting = false
this.audio.maxTime = parseInt(res.target.duration)
},
change: function (val, label) {
var that = this;
if (val.length == 0) {
return;
}
var q_answer = this.list[this.index].q_answer;

if (val == q_answer) {
this.$refs.audio.play();
$(".weui-check_label").find("input[type=checkbox]:checked").each(function (index, item) {
$(item).parents(".weui-check_label").addClass("success");
});
this.$store.state.wordF.success = this.$store.state.wordF.success + 1;
} else {
this.$refs.audioError.play();
$(".weui-check_label").find("input[type=checkbox]:checked").each(function (index, item) {
$(item).parents(".weui-check_label").addClass("error");
});
}
setTimeout(function () {
that.list = that.list.slice(1);
if (that.list.length == 0) {
that.$router.push({
path: '/testResult_hideTabBar', query: {
flag: that.flag
}
});
return;
}
var value = that.list[that.index].q_questionname.toLowerCase();
that.wsongUrl = $.serverInfo.videopath + value + '_b.mp3';
$("#waudio").attr("src", that.wsongUrl);
$(".success").removeClass("success");
$(".error").removeClass("error");
setTimeout(function () {
$("#waudio").get(0).play();
}, 1000);
}, 500);
},
changeWord: function (index) {

var date = dateFormat(new Date(), 'YYYY-MM-DD');





},
playA: function (english) {








$("#waudio").attr("src", english);
setTimeout(function () {
$("#waudio").get(0).play();
}, 500);
},
playB: function (english) {






},
selectTest: function () {
this.$router.push({ path: '/testProject_hideTabBar' })
},
selectStudy: function () {
this.$router.push({ path: '/studyProject_hideTabBar' })
},
hideShadow: function () {

this.showDeil = false;

},
goPre: function () {
this.clearWordNavigateStack();
this.showDeil = true;
if (this.index == 0) {
return;
} else {
this.index = this.index - 1;
}
this.wordinfo = this.wordList[this.index]
this.getWordByid(this.wordinfo.id)










},
goNext: function () {
this.clearWordNavigateStack();
this.showDeil = true;

if (this.index == this.wordList.length - 1) {


this.toastText = "该搜索类型单词你已经学完了。请选择下一本";

return;




}
this.index++
this.wordinfo = this.wordList[this.index]
this.getWordByid(this.wordinfo.id)

}
}
}



// WEBPACK FOOTER //
// ./src/views/word/cell/indexSelect.vue